const PreviousMention = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.4612 6.12592C0.775761 6.507 0.775762 7.49285 1.4612 7.87393L11.4937 13.4516C12.1602 13.8222 12.9796 13.3403 12.9796 12.5776L12.9796 1.4222C12.9796 0.65958 12.1602 0.177627 11.4937 0.548199L1.4612 6.12592Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.04663 0.923828C1.59892 0.923828 2.04663 1.32171 2.04663 1.81253L2.04663 12.0351C2.04663 12.5259 1.59892 12.9238 1.04663 12.9238C0.494347 12.9238 0.0466315 12.5259 0.0466315 12.0351L0.0466309 1.81253C0.0466309 1.32171 0.494346 0.923828 1.04663 0.923828Z"
      fill="currentColor"
    />
  </svg>
);

export default PreviousMention;
